import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function CardBody({ icon, title, description }) {
  return (
    <div className="flex h-full flex-col text-left">
      <div className="flex items-start gap-3">
        {icon && (
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gold-50 text-lg text-gold-600 transition-colors duration-200 ease-in-out group-hover:bg-gold-100">
            <FontAwesomeIcon icon={icon} />
          </span>
        )}
        <p className="mt-1.5 text-base font-semibold leading-tight tracking-tight text-ink">
          {title}
        </p>
      </div>
      {description && (
        <p className="mt-3 text-sm leading-relaxed text-muted">{description}</p>
      )}
    </div>
  );
}

function HomeCard({ icon, title, description, route }) {
  const navigate = useNavigate();
  const base =
    'group h-full w-full rounded-card border border-line bg-surface p-5 shadow-card transition-all duration-200 ease-in-out';

  if (!route) {
    return (
      <div className={base}>
        <CardBody icon={icon} title={title} description={description} />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => navigate(route)}
      className={`${base} text-left hover:-translate-y-0.5 hover:border-gold-300 hover:shadow-card-hover active:translate-y-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2`}
    >
      <CardBody icon={icon} title={title} description={description} />
    </button>
  );
}

export default HomeCard;
